<template>
  <div class="dropdown-arrow">
    <svg v-if="!ascending" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill-opacity="0.54" viewBox="0 0 24 24">
      <path d="M7 10l5 5 5-5z"/>
      <path d="M0 0h24v24H0z" fill="none"/>
    </svg>

    <svg v-if="ascending" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill-opacity="0.54" viewBox="0 0 24 24">
      <path d="M7 14l5-5 5 5z"/>
      <path d="M0 0h24v24H0z" fill="none"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'DropdownArrow',
  props: ['ascending']
}
</script>

<style scoped lang="scss">
@import '../../assets/styles/colors';
@import '../../assets/styles/mixin';

.dropdown-arrow {
  @include flex(row, center, center);
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/assets/DropdownArrow.vue